import ChangeTheme from './modules/ChangeTheme';
import Loader from './modules/Loader';

class Index {
  constructor() {
    let menuEl = document.querySelector('nav .menu.list');
    let bannerEl = document.querySelector('.banner_slider');
    let homeSlidesEl = document.querySelector('.home_slides');
    let pagesEl = document.querySelector('.headline__panel.pages');
    this.body = document.querySelector('body');
    this.loader = new Loader();


    new ChangeTheme(window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0, 100);
    

    if (menuEl) {
      require.ensure([
            './modules/RespMenu'
        ], (require)=> {
        const Menu = require('./modules/RespMenu').default;
        new Menu(menuEl);
      });
    }

    if (bannerEl) {
      require.ensure([
            './app/banner'
        ], (require)=> {
        const Banner = require('./app/banner').default;
        new Banner(bannerEl);
      });
    }
    if (pagesEl) {
      require.ensure([
            './modules/IndiScroller'
        ], (require)=> {
        const IndiScroller = require('./modules/IndiScroller').default;
        new IndiScroller();
      });
    }

    if (homeSlidesEl) {
      require.ensure([
            './app/etalage'
        ], (require)=> {
        const Etalage = require('./app/etalage').default;
        new Etalage(homeSlidesEl);
      });
    }
    this.loader.onReady(()=> {
      this.body.className = `loaded ${this.body.className}`;
      const mainPanel = document.querySelector('body.loaded .main__panel');
      if (mainPanel) {
        if (!mainPanel.style.opacity) {
          mainPanel.style.opacity = 1;
          this.body.className = ` ${this.body.className}`;
          setTimeout(()=> {
            
            this.body.className = `loaded ${this.body.className}`;
          }, 500);
          
        }
      }
    });
  }
  
}

window.addEventListener('load', new Index());



// WEBPACK FOOTER //
// ./index.js